interface CheckmarkProps {
  stroke?: string;
  size?: string;
}

const CheckmarkIcon = ({
  stroke = 'var(--fill-brand)',
  size = '16',
}: CheckmarkProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M2.5 8.5L6 12L13.5 4.5'
      stroke={stroke}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default CheckmarkIcon;
